module.exports = __webpack_public_path__ + "media/images/libro-reclamaciones-color-53f8bcf0d820f35fa6655c6dacc44f54.png";